import React, { useRef } from 'react';
import { withRouter } from 'react-router-dom';

import { REFS } from '../../config/routes';

import './contact.less';

const Contact = () => {
  return (
    <section
      className={'cdo-section cdo-section-contact'}
      ref={useRef(REFS.contact)}
    >
      <h2>CONTACTO</h2>
    </section>
  );
};

export default withRouter(Contact);
